import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicNFAConversion = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Conversion of NFA with Epsilon to NFA without Epsilon"
      videos={[
        "https://www.youtube.com/embed/vqvRRUXKGPw",
        "https://www.youtube.com/embed/Vobgo5t5SQA",
      ]}
      takeaways={[
        { text: "Understand the concept of ε-NFA and how it differs from NFA." },
        { text: "Learn the step-by-step process to remove epsilon transitions." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicNFAConversion };
